// This file was automatically generated from appchart.dialog.viewAllTemplates.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.viewAllTemplates');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.viewAllTemplates.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><p class="el8Italic el8Gray el8AlignCenter padt10" data-testid="template-text-instruction">Click a template below to use it.</p>', (opt_data.settingsUrl) ? '<p class="el8AlignCenter"><a href="' + soy.$$escapeHtml(opt_data.settingsUrl) + '" data-testid="template-edit-link" target="_blank" rel="noopener">add/edit/delete templates</a></p>' : '', '<ul class="ordersetContainer">');
  var templateList2860 = opt_data.templates;
  var templateListLen2860 = templateList2860.length;
  if (templateListLen2860 > 0) {
    for (var templateIndex2860 = 0; templateIndex2860 < templateListLen2860; templateIndex2860++) {
      var templateData2860 = templateList2860[templateIndex2860];
      output.append('<li class="template-item item" data-id="', soy.$$escapeHtml(templateData2860.id), '"><div class="ordersetTitle"><span class="el8BrandDark el8Bold">', soy.$$escapeHtml(templateData2860.name), '</span></div><div class="ordersetDetails">');
      if (templateData2860.modelClass == 'LetterTemplate') {
        el8.template.appchart.dialog.viewAllTemplates.letterTemplateDetails(templateData2860, output);
      }
      output.append('</div></li>');
    }
  } else {
    output.append('<p class="el8FeedEmpty">No templates created yet</p>');
  }
  output.append('</ul></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.viewAllTemplates.letterTemplateDetails = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.subject) ? '<p class="itemNoTextSaved"><span class="frame elt">Subject:</span> <span>' + soy.$$escapeHtml(opt_data.subject) + '</span></p><br>' : '', '<p class="itemNoTextSaved"><span class="frame elt">Body:</span> <span class="el8Preserve">', soy.$$escapeHtml(opt_data.body), '</span></p>');
  if (!opt_sb) return output.toString();
};
